import imageExtensions from 'image-extensions';
import { Node } from 'slate';
import { isElementType, isUrl } from '.';
import { ImageElement } from '../types';

// Is node an image
export const isImage = (node: Node): node is ImageElement =>
	isElementType(node, 'image');

// Is string a valid image URL
export const isImageUrl = (url: any): url is string => {
	if (!isUrl(url)) return false;
	const extension = new URL(url).pathname.split('.').pop();
	return extension ? imageExtensions.includes(extension) : false;
};
